// import { ApiService } from '@/services/bricmate/ApiService';
import { ApiService2 } from '@/services/bricmate/ApiService2';

import { orderCatalog } from "@/models/bricmate/orderCatalog";
import ThankYouModal from "./ThankYouModal.vue";
import { extend } from 'vee-validate';

export default {
    name: 'CatalogForm',
    data() {
      return {
        orderForm: {
          firstname: '',
          lastname: '',
          address: '',
          email: '',
          phonenumber: '',
          postalcode: '',
          city: '',
          mainCatalog: true,
          outSideCatalog: false,
          counterTopCatalog: false,
        } as orderCatalog,
        showThankYouModal: false,
      }
    },
    props: ["viewmodel"],
    components: {
      ThankYouModal
    },
    computed: {
      translations() {
        return window.__litium.translation;
      }
    },
    created() {
      const phoneRegex = /^(?:\+|00)?[\d\s-]{7,15}$/;      
      const postalCodeRegex = /^(\d{4}|\d{3}\s?\d{2})$/;
  
      extend('validPhone', {
        validate: value => phoneRegex.test(value),
      });
  
      extend('postalCode', {
        validate: value => postalCodeRegex.test(value),
      });
    },
    methods: {
      onSubmit() {
        ApiService2.orderCatalog(this.orderForm).then((response) => {
          if (response && response.status == 200) {
            this.showThankYouModal = true;
          } 
        });
      },
      resetForm() {
        this.orderForm = {
          firstname: '',
          lastname: '',
          address: '',
          email: '',
          phonenumber: '',
          postalcode: '',
          city: '',
          mainCatalog: true,
          outSideCatalog: false,
          counterTopCatalog: false,
        };
  
        this.$nextTick(() => this.$refs.observer.reset());
      },
      handleCloseModal() {
        this.showThankYouModal = false;
        this.resetForm();
      }
    },
  }
  
